import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import OptionsLandschaftGroupViewModel from '@/ViewModels/Controls/OptionsLandschaftGroupViewModel';

export default class OptionsLandschaftViewModel extends ControlViewModel {
    
    public groups: KnockoutObservableArray<OptionsLandschaftGroupViewModel>;

    public constructor(protected params: any) {  
        super(params);

        this.groups = this.observableOrDefault(params.groups, []) as KnockoutObservableArray<OptionsLandschaftGroupViewModel>;
    }

}

ComponentManager.setViewModel('OptionsLandschaftViewModel', OptionsLandschaftViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');